import {
    fetchKeysFailure,
    fetchKeysRequest,
    fetchKeysSuccess
} from '../reducers/core/keysReducer';
import Fetch from '../util/core/Fetch';
import CryptoJS from 'crypto-js';
import { getUserSession } from '../util/core/Session';
import config from '../../application/config/config';

const SHARED_SECRET_KEY = process.env.REACT_APP_SHARED_SECRET_KEY;

function decryptDataFromBackend(encryptedString) {
    try {
        const parts = encryptedString.split(':');
        if (parts.length !== 2) {
            return null;
        }

        const ivHex = parts[0];
        const encryptedData = parts[1];

        const iv = CryptoJS.enc.Hex.parse(ivHex);
        const key = CryptoJS.enc.Utf8.parse(SHARED_SECRET_KEY.slice(0, 32));

        const decrypted = CryptoJS.AES.decrypt(
            { ciphertext: CryptoJS.enc.Hex.parse(encryptedData) },
            key,
            { iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
        );

        return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    } catch (error) {
        return null;
    }
}

export const fetchEncryptedKeysThunk = () => {
    return async (dispatch) => {
        const session = getUserSession();

        dispatch(fetchKeysRequest());
        try {
            const response = await Fetch.post(
                `${config.endpoints.backend}core/configs/getByInstance`,
                {
                    core_application_instance_id:
                        session?.user?.application_instance_id
                }
            );

            const configs = response.reduce((acc, item) => {
                if (item.config) {
                    const decryptedData = decryptDataFromBackend(item.config);

                    acc[item.reference] = decryptedData;
                }
                return acc;
            }, {});


            dispatch(fetchKeysSuccess(configs));
        } catch (error) {
            dispatch(fetchKeysFailure(error.message));
        }
    };
};
